export default "__VITE_ASSET__BaQ4d_rs__"